<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        CRT点位地址表管理
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
            </div> -->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <!-- <el-button type="info" size="small"  
            plain @click="downmuban()">下载模板</el-button>

          <el-upload
          class="ml10"
            :action="config.apiUrltest+'crtarea/importcrt'"

            :headers="{token:$store.state.token}"
            :show-file-list='false'
            :on-success="handlesuccess"
          >
            <el-button size="small" type="success"    
            >导入文件</el-button>
          </el-upload> -->
        <!-- <el-button class="ml10" size="small" @click="output() "   
             type="primary" plain >导出文件</el-button> -->
        <div
          v-hasPermi="['crtpoint:crtaddress:query']"
          class="btn ml10"
          @click="showDia = true"
        >
          <i class="icon-tr-search"></i>查询
        </div>
        <router-link
          class="btn ml20"
          v-hasPermi="['crtpoint:crtaddress:add']"
          :to="{
            path: '/qvyu/qvyu-place-add',
            query: { area_uuid: $route.query.id, c_num: $route.query.c_num },
          }"
          ><i class="icon-tr-newly-added"></i>新增</router-link
        >
      </div>
      <div class="">
        <el-table :data="list" class="">
          <el-table-column prop="number" label="部位号" align="center">
          </el-table-column>
          <el-table-column prop="true_addr" label="真实地址" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <router-link
                v-hasPermi="['crtpoint:crtaddress:edit']"
                :to="{
                  path: '/qvyu/qvyu-place-add',
                  query: {
                    area_uuid: $route.query.id,
                    id: scope.row.point_uuid,
                    c_num: $route.query.c_num,
                  },
                }"
              >
                <el-button size="mini" type="warning">编辑</el-button>
              </router-link>
              <el-popconfirm
                title="确定禁用此记录吗？"
                v-hasPermi="['crtpoint:crtaddress:remove']"
                class="cursor"
                @confirm="changeStatus(scope.row.point_uuid, 0)"
                @onConfirm="changeStatus(scope.row.point_uuid, 0)"
              >
                <a slot="reference" class="red">
                  <el-button type="danger" size="mini">删除</el-button>
                </a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.limit || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="reset" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getDeviceList, editDevice } from "../../api/device";
import config from "../../utils/config";
export default {
  data() {
    return {
      list: [],
      params: {
        page: 1,
        number: "",
        limit: 10,
        true_addr: "",
        area_uuid: this.$route.query.id,
      },
      config: config,
      total: 0,
      showDia: false,
      searchForm: this.$getForm("crtaddrsearch"),
      editData: {},
      remoteFuncs: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // handlesuccess(res){
    //   if(res.code==200){
    //            this.$message.success('导入成功')
    //       this.getList()
    //   }else{
    //       this.$message.error(res.msg)

    //   }

    // },
    reset() {
      this.showDia = false;
      // this.resetSearch();
    },
    changeStatus(id, status) {
      // editDevice({id:id,status:status}).then(res=>{
      //     this.getList()
      // }).catch(err=>{

      // })
      this.$post(`/crt/crtdel/${id}`)
        .then((res) => {
          // this.$message.success("删除成功");
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((e) => {});
    },
    //  downmuban(){
    //   var url = `${config.apiUrltest}/crtarea/crttemplate?c_company_num=${this.$route.query.c_num}`
    //   window.open(url,"_blank")
    // },
    getList() {
      this.$post("/crt/crtlist", this.params).then((res) => {
        this.total = res.count;
        this.list = res.data;
      });
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { page: 1, limit: 10, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped></style>
